// Suppress the harmless "ResizeObserver loop" warning from React's dev overlay.
// React's overlay listens via window.addEventListener('error', ...) so we must
// intercept in the CAPTURE phase (3rd arg = true) to stop it before they see it.
window.addEventListener(
  'error',
  (e) => {
    if (e?.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation(); // prevent React overlay from catching it
    }
  },
  true // capture phase — runs before React's own listener
);

import React from 'react';
import ReactDOM from 'react-dom/client';
import Highcharts from 'highcharts';

// Global Highcharts Configuration for all charts in the project
Highcharts.setOptions({
    chart: {
        backgroundColor: '#FFFFFF',
        style: {
            fontFamily: 'inherit'
        }
    },
    exporting: {
        chartOptions: {
            chart: {
                backgroundColor: '#FFFFFF'
            }
        }
    },
    navigation: {
        buttonOptions: {
            theme: {
                fill: '#FFFFFF'
            }
        }
    }
});
import "@fontsource/montserrat"; // Defaults to 400 weight
// App.js or index.js
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/600.css";

import './index.css';
import App from './App';
import './styles/buttons.css';
import { UserProvider } from './contexts/UserContext';
import { ClientProvider } from './contexts/ClientContext';
import { AssignedToProvider } from './contexts/AssignedToContext'; 
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <UserProvider>
        <ClientProvider>
          <AssignedToProvider>
            <App />
          </AssignedToProvider>
        </ClientProvider>
      </UserProvider>
    </StyleSheetManager>
  </React.StrictMode>
);
